import { Row } from 'antd'
import KTag from 'app/components/UI-Elements/DataDisplay/KTag'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import * as React from 'react'

import { MemberProps } from '../../convention'

const Item: React.FC<MemberProps<IDocument>> = ({ member }) => {
  const getIcon = (type: string) => <Icon iconStyles={{ height: 16, width: 16 }} type={type} />

  return (
    <If condition={member}>
      <Row gutter={[0, 12]}>
        <KCol span={24}>
          <div className="d-flex full-width">
            <span className="mr-auto my-auto">
              <strong>{member.name}</strong>
            </span>
          </div>
        </KCol>
        <KCol>
          <KTag text={<span>{member.created_at}</span>} icon={getIcon('calender')} type="info" />
        </KCol>
        <KCol>
          <KTag text={member.created_by} icon={getIcon('user-avatar')} type="info" />
        </KCol>
        <KCol>
          <KTag text={member.document_type} icon={getIcon('contract')} type="info" />
        </KCol>
      </Row>
    </If>
  )
}

export default Item
